export const BestIcon = ({ checked, size = 24 }: { checked?: boolean; size?: number }) => {
  return (
    <svg width={size} height={size} viewBox={'0 0 24 24'} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2295 4.14427C10.9537 2.61858 13.0462 2.61858 13.7705 4.14427L15.0221 6.78106C15.3097 7.38691 15.8656 7.80684 16.5087 7.904L19.3074 8.32682C20.9268 8.57148 21.5734 10.6406 20.4016 11.8282L18.3764 13.8806C17.9111 14.3522 17.6988 15.0317 17.8086 15.6976L18.2867 18.5957C18.5633 20.2726 16.8704 21.5514 15.422 20.7596L12.9187 19.3913C12.3436 19.0769 11.6564 19.0769 11.0813 19.3913L8.57799 20.7596C7.12955 21.5514 5.43668 20.2726 5.71331 18.5957L6.19139 15.6976C6.30124 15.0317 6.0889 14.3522 5.62357 13.8806L3.59839 11.8282C2.42658 10.6406 3.0732 8.57148 4.69259 8.32682L7.49134 7.904C8.1344 7.80684 8.69031 7.38691 8.9779 6.78106L10.2295 4.14427Z"
        fill={checked ? '#FFFFFF' : '#222530'}
      />
    </svg>
  );
};
